import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Alert
} from "reactstrap";
import OrderStatusManager from "./OrderStatusManager";
import ReactToPrint from "react-to-print";
import moment from "moment";
import Switch from "react-switch";
import Countdown from "react-countdown-now";
import RequestManager from "../../singletons/RequestManager";
import Confirm from "./Confirm";
// import { stringify } from "querystring";
const orderStatusManager = new OrderStatusManager();
// Renderer callback with condition
const rendererTimer = ({ minutes, seconds, completed }) => {
  if (completed) {
    // Render a complete state
    return (
      <p
        style={{
          alignItems: "center",
          padding: 2,
          textAlign: "center",
          justifyContent: "center"
        }}
      >
        00:00{" "}
      </p>
    );
  } else {
    // Render a countdown
    return (
      <p
        style={{
          alignItems: "center",
          padding: 2,
          fontSize: 25,
          justifyContent: "center"
        }}
      >
        {minutes}:{seconds}
      </p>
    );
  }
};
export default class DetailedOrderCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeLeft: "00:00",
      orderId: null,
      orderModalVisible: false,
      order: null,
      printRef:null,
      printRollCount:0
    };
  }

  componentWillMount() {
    console.log("ORDER PROPS",JSON.stringify(this.props.storeInformation))
    this.fetchOrderDetails()
  
  }
 
  toggleChange = cartItem => {
    this.setState({
      isChecked: !cartItem.status
    });
  };

  getCountOfItems = () => {
    let cartItems = this.state.order.node.cart.cartItems.edges;
    let quantity = 0;
    cartItems.forEach(cartItem => {
      quantity = quantity + cartItem.node.quantity;
    });

    return quantity;
  };


  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  render() {
    let vehicleDetails = this.props.order.node.cart.checkout.mode;
    let vehicleString = "Walking";
    if (!!vehicleDetails) {
      vehicleString = vehicleDetails;
      // vehicleString = vehicleDetails.model + " " + vehicleDetails.registration;
    }
    return (
      <div>
        {
          this.state.order === null ? 
          <div>
            <ModalHeader toggle={this.props.goBack}>
            </ModalHeader>
            <ModalBody>
            <p>
              {"Getting Order Details."}
            </p>
            </ModalBody>
          </div>
          :
          <div>
            <Modal
              size="lg"
              isOpen={this.state.orderModalVisible}
              toggle={this.toggleModal}
            >
              <Confirm
                editable={true}
                order={this.state.order}
                toggleFullFilled={this.toggleFullFilled}
                goBack={this.toggleModal}
              />
            </Modal>
        
            <ModalBody>
            <div
            style={{
            display: "flex",
            flexDirection: "row",
            justifyContent:"space-between",
            marginBottom:15,
            paddingBottom:10,
            borderBottom: "1px solid #ECECEC",
            }}
            > 
          
            {
              this.state.order.node.status === 'PUSHED' ?
                this.renderActionAcceptAndReject()
              :
                <ReactToPrint
                    trigger={() => (
                    <Button color="primary" href="#">
                    RePrintOrder
                    </Button>
                )}
                content={() => this.printDiv}
                />
                
            }      
            { this.state.order === null ? null : <div hidden={true}>{this.renderPrintComponent()}</div>}
          
             <Button style={{color: 'white',backgroundColor:'red',
              }} onClick ={this.props.goBack}> Cancel</Button>
            
          </div>
              <div>
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                  {"Token: " + this.getToken()}
                </p>
              
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                  {"Mode: " + vehicleString}
                </p>
                {
                  this.props.order.node.cart.checkout.codeType === 'AEP' ?
                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {this.props.order.node.cart.checkout.codeType +": "+ this.props.order.node.cart.checkout.code}
                  </p>
                  : null
                }
                
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                  {"Pickup Point: " + this.state.order.node.cart.pickupPoint.name}
                </p>
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                  {"User Mobile: " + this.state.order.node.user.phone}
                </p>
                {
                  this.state.order.node.user.userProfile.firstName === null
                    ?
                      null
                    :
                      <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                        {"User Name: " +
                          this.state.order.node.user.userProfile.firstName +
                          " " +
                          this.state.order.node.user.userProfile.lastName}
                      </p>
                }
                {this.state.order.node.cart.specialInstructions === null ? null : (
                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {"Special Instructions: " +
                      this.state.order.node.cart.specialInstructions}
                  </p>
                )}
                <p style={{ margin: 0, padding: 0 }}>
                  {this.getCountOfItems()+ " Item(s)"}
                </p>
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                {"OrderID: " + this.state.order.node.orderId}
                </p>
                <p style={{ margin: 0, padding: 0 }}>
                  { "Order Push:" + moment(this.state.order.node.pushedAt === null ? this.state.order.node.createdAt : this.state.order.node.pushedAt).format(
                    "MMMM Do YYYY, h:mm a"
                  )}
                </p>
                <Table responsive style={{ marginTop: 20, marginBottom: 20 }}>
                  <tbody>
                    <tr>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                      {
                        this.props.bussiness === "Grocery" ? 
                        <th>Status</th>
                        : null
                      }
                    </tr>
                    {this.state.order.node.cart.cartItems.edges.map(cartItem => (
                      <tr key={cartItem.node.id}>
                        <td>
                          <div>
                            {this.getProductName(cartItem)}
                            {cartItem.node.customizations.edges.length > 0 ? (
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between"
                                  }}
                                >
                                  <p
                                    style={{
                                      marginBottom: 10,
                                      marginTop: 10,
                                      padding: 0,
                                      fontWeight: "bold"
                                    }}
                                  >
                                    {"Customizations"}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: 10,
                                      marginTop: 10,
                                      padding: 0,
                                      fontWeight: "bold"
                                    }}
                                  >
                                    {"Amount"}
                                  </p>
                                </div>
                                {cartItem.node.customizations.edges.map(
                                  customization => {
                                    return (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between"
                                        }}
                                      >
                                        <p>
                                          {customization.node.parent.name +
                                            " - " +
                                            customization.node.name}
                                        </p>
                                        <p>
                                          {"₹" + customization.node.settlementPrice}
                                        </p>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </div>
                        </td>
                        <td>{cartItem.node.quantity}</td>
                        <td>
                          {"₹" +
                            cartItem.node.settlementPrice / cartItem.node.quantity +
                            " × " +
                            cartItem.node.quantity +
                            " = ₹" +
                            cartItem.node.settlementPrice}
                        </td>
                        <td>
                          { this.props.bussiness === "Grocery" ?
                            this.props.pastOrder === true ? (
                            <Switch
                              disabled={true}
                              onChange={checked => {}}
                              checked={
                                cartItem.node.status === "FULFILLED" ? true : false
                              }
                            />
                            ) : 
                            (<Switch
                              disabled={
                                this.props.bussiness === "Grocery"
                                  ? cartItem.node.status === "FULFILLED"
                                    ? false
                                    : true
                                  : true
                              }
                              onChange={checked => {
                              }}
                              checked={
                                cartItem.node.status === "FULFILLED" ? true : false
                              }
                            />)
                            : null
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {this.renderAdditionalCharges(
                  this.state.order.node.cart.settlementExtra
                )}
                <p
                  style={{
                    margin: 0,
                    padding: 0,
                    fontWeight: "bold",
                    textAlign: "left"
                  }}
                >
                  {"Total Price: ₹" + this.state.order.node.cart.settlementPrice}
                </p>
                
              </div>
            </ModalBody>
            <ModalFooter>{this.renderActionButtons()}</ModalFooter>
          </div>
          }
        </div>
    );
  }
  getToken = () =>{
    let token = JSON.stringify( this.state.order.node.storeToken);
    if(token.length <= 4){
      if(token.length === 1){
        token= "000"+token;
      }else if(token.length === 2){
        token= "00"+token;
      }else if(token.length === 3){
        token= "0"+token;
      }
    }
    return token;
  }

  renderReadyActionButton = () => {
    return this.props.order.node.status === "PUSHED" ||
      this.state.order.node.status === "DELIVERED" ||
      this.state.order.node.status === "REJECTED" ||
      this.state.order.node.status === "NEW" ? null : (
      <Alert
        color={
          this.state.order.node.status === "ACCEPTED" ? "warning" : "success"
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          <div>
            {this.state.order.node.status === "READY" ? (
              <h4>Item is ready</h4>
            ) : (
              <div>
                <h4>Time Remaining</h4>
                <Countdown
                  date={moment() + this.getCountDownTime()}
                  renderer={rendererTimer}
                />
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center"
            }}
          >
            <Button
              color={
                this.state.order.node.status === "ACCEPTED"
                  ? "primary"
                  : "secondary"
              }
              disabled={
                this.state.order.node.status === "ACCEPTED" ? false : true
              }
              onClick={() => {
                this.updateOrderStatus("READY")
              }}
            >
              ORDER IS READY
            </Button>
          </div>
        </div>
      </Alert>
    );
  };
  getCountDownTime = () => {
    let readyTime,ms;
    if(this.props.order.node.pushedAt !== null){
      if(this.props.order.node.sla !== null)
        readyTime = moment(this.props.order.node.pushedAt).add(this.props.order.node.sla,"s");
      else
        readyTime = moment(this.props.order.node.pushedAt).add(900,"s");
      // if (this.props.order.node.cart.pickupPoint.sla.pushType && this.state.order.node.cart.pickupPoint.sla.pushType === "TIME") {
      //   readyTime = moment(this.state.order.node.pushedAt).add(
      //     this.state.order.node.cart.pickupPoint.sla.pushValue,
      //     "s"
      //   );
      // } else {
      //   readyTime = moment(this.state.order.node.pushedAt).add(
      //     this.state.order.node.cart.pickupPoint.sla.preparationTime,
      //     "s"
      //   );
      // }
      
    ms =  moment.duration(readyTime.diff(moment())).minutes() * 60 * 1000 +
      moment.duration(readyTime.diff(moment())).seconds() * 1000;
    }else{
      ms = 0
    }
    return ms;
  };
  getProductName = cartItem => {
    let name = cartItem.node.stock.referenceName;
    if (cartItem.node.stock.sku.quantity != null) {
      name = name + " - " + cartItem.node.stock.sku.quantity;
    }
    if (cartItem.node.stock.sku.unit != null) {
      name = name + " - " + cartItem.node.stock.sku.unit;
    }
    // if (cartItem.node.stock.sku.description == null) {
    //   name = cartItem.node.stock.sku.name;
    // } else {
    //   name =
    //     cartItem.node.stock.sku.name +
    //     " - " +
    //     cartItem.node.stock.sku.description;
    // }
    // if (cartItem.node.stock.sku.quantity != null) {
    //   name = name + " - " + cartItem.node.stock.sku.quantity;
    // }
    // if (cartItem.node.stock.sku.unit != null) {
    //   name = name + " - " + cartItem.node.stock.sku.unit;
    // }

    return name;
  };
  renderActionAcceptAndReject = () =>{
    if(this.state.order.node.status === 'PUSHED' || this.state.order.node.status === 'NEW' ){
      return (
        <div style={{display: "flex",flex:1}}>

              <div style={{
                display: "flex",
                flexDirection: "row",}}>
                <div style= {{backgroundColor :"red",marginRight:20,paddingTop:6}} >
                <a  style= {{color:'white',padding:16,}} >REJECT</a>
                </div>
                <div style= {{backgroundColor :"green",paddingTop:6}} >
                    <a  style= {{color:'white',padding:16}}>Accept</a>
                  
                </div>
              </div>

          
          
          
        </div>
      );
    }
  }
  printCount =(order)=>{
    // Print Count per order
    let defaultLines = 16,cusLen=0,AEPCount=0,finalCount=0;
    let productLen = order.node.cart.cartItems.edges.length;
    if(order !== null){
      if(order.node.cart.checkout.codeType !== null ){
        if(this.props.order.node.cart.checkout.codeType === 'AEP')
        {
          AEPCount = AEPCount+1;
        }
      }
      
      for(let i=0; i <  order.node.cart.cartItems.edges.length; i++)
      {
        
        console.log("print Order",JSON.stringify(order))
        let referenceNameLen =  order.node.cart.cartItems.edges[i].node.stock.referenceName.length;
        
        if(referenceNameLen > 21)
        {
          productLen = productLen + 1;
        }
        cusLen = order.node.cart.cartItems.edges[i].node.customizations.edges.length;
        for(let j=0 ; j< order.node.cart.cartItems.edges[i].node.customizations.edges.length; j++){
          let cname= order.node.cart.cartItems.edges[i].node.customizations.edges[j].node.name
          
          let parent = order.node.cart.cartItems.edges[i].node.customizations.edges[j].node.parent.name;
        
          if((parent +":"+cname).length > 21){
            cusLen = cusLen + 1;
          }
        }
      }
      if(cusLen > 0){
        cusLen = cusLen+1;
      }

      finalCount = defaultLines + productLen + cusLen + AEPCount;

      return finalCount;

  }else{
    return finalCount;
  }
}

  updateOrderStatus =(status)=>{
    let printCount = 0;
    if(this.props.storeInformation.store && this.props.storeInformation.store.shouldPrintViaApp === true)
    {
      if(status === "ACCEPTED")
      {
         printCount = this.state.printRollCount;
      }
    }
    
    orderStatusManager.updateOrderStatus(
      this.state.order.node.id,
      status,printCount
    );
    this.props.refreshOrders();
    this.props.goBack();
   
      // if(this.props.order.node.user.userProfile.codeType !== null && 
      //   this.props.order.node.user.userProfile.codeType === 'AEP' && 
      //   this.props.order.node.user.userProfile.codeVerified === false){}
      

  }

  renderActionButtons = () => {
    if (this.props.editable) {
      switch (this.state.order.node.status) {
         
          case "DELIVERED":
          return (
            <div style= {{backgroundColor :"green"}} >
                <a  style= {{color:'white',padding:10}} 
                >DELIVERED</a> 
            </div>
          );
          case "REJECTED":
          return (
            <div style= {{backgroundColor :"green"}} >
                <a  style= {{color:'white',padding:10}} 
                >REJECTED</a>

            </div>
          );
        case "READY":
        return (
          
        <div style= {{backgroundColor :"green",padding:6}} >
            <a  style= {{color:'white'}}>Completed</a>   
        </div>
        );

        default:
          return (
            <div>
            </div>
          );
      }
    } else {
      return null;
    }
  };

  renderCustomizations = extraText => {};
  renderAdditionalCharges = extraText => {
    let extra = JSON.parse(extraText);
    let offers = extra.offer === null ? [] : extra.offer;
    let charges = extra.charge === null ? [] : extra.charge;
    return (
      <div style={{}}>
        {charges && charges.map((charge, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <p>{charge.label}</p>
              <p>{"₹" + charge.amount}</p>
            </div>
          );
        })}
        {offers && offers.map((offer, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <p>{offer.label}</p>
              <p>{"₹" + offer.amount}</p>
            </div>
          );
        })}
      </div>
    );
  };

 

  fetchOrderDetails = async () => {
    let requestManager = new RequestManager();
    let params = {
      orderId: this.props.order.node.orderId
      };
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getOrderDetails",params
    );
    console.log("params",JSON.stringify(response))
    if (response.error === null) {
      console.log("resp",JSON.stringify(response.data))

      let order = response.data.orderDetails.edges[0];
    
      this.setState({ order: order});


    } else {
      alert("Something went wrong try again.");
      console.log("Connection to server failed.");
    }   
  };

  renderPrintComponent = () => {
    //console.log(this.props.order)
    let vehicleDetails = this.props.order.node.cart.checkout.mode;
    let vehicleString = "Walking";
    if (!!vehicleDetails) {
      vehicleString = vehicleDetails;
      // vehicleString = vehicleDetails.model + " " + vehicleDetails.registration;
    }

    return (
      <div
        style={{ fontWeight: "bold", fontSize: 20, padding: 10 }}
        ref={printDiv => {
          this.printDiv = printDiv;
        }}
      >
        <p style={{ textAlign: "center" }}>GRABBNGO ORDER</p>
        <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          {"Token " + this.props.order.node.storeToken}
        </p>
        
        <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          {"Mode: " + vehicleString}
        </p>
        {
          this.props.order.node.cart.checkout.codeType === 'AEP' ?
          <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
            {this.props.order.node.cart.checkout.codeType +": "+ this.props.order.node.cart.checkout.code}
          </p>
          : null
        }
        <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          {"Pickup Point: " + this.props.order.node.cart.pickupPoint.name}
        </p>
        {
           this.props.order.node.user.userProfile.firstName === null
          ?
          null
          :
          <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
            {"User Name: " +
              this.props.order.node.user.userProfile.firstName +
              " " +
              this.props.order.node.user.userProfile.lastName}
          </p>
        }
        <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          {"User Mobile: " + this.props.order.node.user.phone}
        </p>
        {this.state.order.node.cart.specialInstructions === null ? null : (
          <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
            {"Special Instructions: " +
              this.state.order.node.cart.specialInstructions}
          </p>
        )}
        <p style={{ margin: 0, padding: 0 }}>
          {this.getCountOfItems() + " Item(s)"}
        </p>
        <Table responsive style={{ marginTop: 20, marginBottom: 20 }}>
          <tbody>
            <tr style={{ fontWeight: "bold", fontSize: 20 }}>
              <th>Product</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
            {this.state.order.node.cart.cartItems.edges.map(cartItem => (
              <tr
                key={cartItem.node.id}
                style={{ fontWeight: "bold", fontSize: 20 }}
              >
                <td>
                  {this.getProductName(cartItem)}
                  {cartItem.node.customizations.edges.length > 0 ? (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}
                      >
                        <p
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            padding: 0,
                            fontWeight: "bold"
                          }}
                        >
                          {"Customizations"}
                        </p>
                        <p
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            padding: 0,
                            fontWeight: "bold"
                          }}
                        >
                          {"Amount"}
                        </p>
                      </div>
                      {cartItem.node.customizations.edges.map(customization => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between"
                            }}
                          >
                            <p>
                              {customization.node.parent.name +
                                " - " +
                                customization.node.name}
                            </p>
                            <p>{"₹" + customization.node.settlementPrice}</p>
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </td>
                <td>{cartItem.node.quantity}</td>
                <td>
                  {"₹" +
                    cartItem.node.settlementPrice / cartItem.node.quantity +
                    " × " +
                    cartItem.node.quantity +
                    " = ₹" +
                    cartItem.node.settlementPrice}
                </td>
                <td> {cartItem.node.status} </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {this.renderAdditionalCharges(
          this.state.order.node.cart.settlementExtra
        )}
        <p
          style={{
            margin: 0,
            padding: 0,
            fontWeight: "bold",
            textAlign: "left"
          }}
        >
          {"Total Price: ₹" + this.state.order.node.cart.settlementPrice}
        </p>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/MerchantDetailedOrderCard.js